module.exports = __webpack_public_path__ + "img/brothers.191e867a.svg";